export default "__VITE_ASSET__BGLj$NB8__"